<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">订单号：</span>
					<el-input v-model="search_orderNo" class="b_inp" placeholder="订单号" clearable></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">手机号：</span>
					<el-input v-model="search_orderPhone" class="b_inp" placeholder="手机号" clearable></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchDateChange"
					></el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchDateChange"
					></el-date-picker>
				</div>
			<!-- 	<div class="b_item">
					<span class="b_label">类型：</span>
					<el-select v-model="type" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option value="lvbo" label="镜片验配"></el-option>
						<el-option value="lvbo2" label="双眼滤波评估"></el-option>
					</el-select>
				</div> -->
				<!-- 	<div class="b_item">
					<span class="b_label">支付类型：</span>
					<el-select v-model="search_payType" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in appPayType" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div> -->
				<div class="b_item">
					<span class="b_label">订单状态：</span>
					<el-select v-model="search_orderStatus" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in statusList" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<!-- 	<div class="b_item">
					<span class="b_label">流水号：</span>
					<el-input v-model="search_serial" class="b_inp" placeholder="流水号"></el-input>
				</div> -->
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			<div style="text-align: right">
				<el-button type="primary" @click="add('add')">添加</el-button>
			</div>
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column type="index" width="120" label="序列"></el-table-column>
					<el-table-column prop="coinDetailId" label="订单号"></el-table-column>
					<el-table-column width="150" label="图片">
						<template slot-scope="scope">
							<el-image :src="scope.row.orderImg" style="width: 100px; height: 100px" />
						</template>
					</el-table-column>
					<el-table-column prop="hasFrame" label="自带框架" align="center">
						<template v-slot:default="scope">
							<span v-if="scope.row.hasFrame == 1">是</span>
							<span v-else>否</span>
						</template>
					</el-table-column>
					<el-table-column prop="orderPhone" label="手机号"></el-table-column>
					<el-table-column prop="date" label="发货公司" align="center">
						<template #default="scope">
							<span>{{ scope.row.kdCodeReturn || '/' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="date" label="发货单号" align="center">
						<template #default="scope">
							<span>{{ scope.row.orderNoReturn || '/' }}</span>
						</template>
					</el-table-column>
					<!-- 	<el-table-column width="300" prop="addr" label="收货地址"></el-table-column> -->
					<!-- 		<el-table-column prop="uCode" label="主治医生"></el-table-column> -->
					<!-- 	<el-table-column prop="sendLabel" label="订单状态">
						<template slot-scope="scope">
							<div v-for="v in statusList" :key="v.id">
								<span v-if="v.id == scope.row.orderStatus">
									{{ v.name }}
								</span>
							</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="orderStatus" label="订单状态" align="center">
						<template slot-scope="scope">
							<div v-for="v in statusList" :key="v.id">
								<span v-if="v.id == scope.row.orderStatus">
									{{ v.name }}
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="orderPhone" label="手机号"></el-table-column>
					<!-- <el-table-column prop="testCreateTs" label="检测类型">
						<template slot-scope="scope">
							<span>{{ scope.row.type == 'lvbo' ? '镜片验配' : '双眼滤波评估' }}</span>
						</template>
					</el-table-column> -->
					<el-table-column prop="time" label="创建时间" width="180"></el-table-column>
					<el-table-column label="操作" width="150">
						<template slot-scope="scope">
							<el-button @click="add('view', scope.row)">订单情况</el-button>
							<!-- <el-button @click="handleUpdateClick(scope.row)">修改</el-button> -->
							<el-button @click="handleSendClick(scope.row)">发货</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px">
				<div class="base_pager" style="float: right">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页"
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					></el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>

		<!-- 修改 -->
		<update v-model="update_display" :obj="update_data" @onSuccess="updateSuccess"></update>
		<!-- 新增 end -->

		<!-- 发货 -->
		<send v-model="send_display" :obj="send_data" :orderId="send_id" @onSuccess="sendSuccess"></send>
		<!-- 发货 end -->
		<!-- 添加 -->
		<add v-model="add_display" :obj="add_data" @onSuccess="sendSuccess" :type="add_type"></add>
		<!-- 添加 -->
		<!-- <Test v-model="test_display" :obj="add_data" ></Test> -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Update from './components/update.vue';
import Send from './components/send.vue';
import Add from './components/add.vue';
import Api from '../../../../api/index.js';

export default {
	components: {
		Update,
		Send,
		Add
	},
	mounted() {
		this.getData();
	},
	data() {
		return {
			loading: false,

			search_orderNo: '',
			search_orderPhone: '',
			search_orderStatus: '',

			search_goods: '',
			search_uCode: '',
			search_startDate: '',
			search_endDate: '',
			search_payType: '',
			search_serial: '',
			total: 0,
			currentPage: 1,
			tableData: [],
			update_display: false,
			update_data: {},
			send_display: false,
			send_id: '',
			send_data: {},
			add_display: false,
			add_type: 'add',
			add_data: {},
			type: '',
			// 			镜片验配
			// lvbo
			// 双眼滤波评估
			// lvbo2
			statusList: [
				{
					id: 1,
					name: '未发货'
				},
				{
					id: 2,
					name: '制作中'
				},
				{
					id: 3,
					name: '已发货'
				},
				{
					id: 4,
					name: '已收货'
				}
			]
		};
	},
	computed: {
		...mapState(['appManager', 'appPayType', 'appOrderStatus', 'appSendStatus'])
	},
	methods: {
		/******************** @Events *************************/
		changeStatus() {},
		// 添加
		add(type, obj) {
			console.log(obj);
			this.add_type = type;
			this.add_data = obj;
			this.add_display = true;
		},
		// 切换时间
		handleSearchDateChange() {
			this.compareSearchDate();
		},
		// 点击查询
		handleSearchClick() {
			this.currentPage = 1;
			this.getData();
		},
		// 切换页码
		handlePageChange(page) {
			if (this.currentPage != page) {
				this.currentPage = page;
				this.getData();
			}
		},
		// 点击修改
		handleUpdateClick(obj) {
			console.log(obj);
			this.update_data = { ...obj };
			this.update_display = true;
		},
		// 修改成功
		updateSuccess() {
			this.getData();
		},
		// 点击发货
		handleSendClick(obj) {
			this.send_id = obj.coinDetailId + '';
			this.send_data = obj;
			this.send_display = true;
		},
		// 发货成功
		sendSuccess() {
			this.getData();
		},

		/******************** @Function *************************/
		// 获取数据
		getData() {
			const that = this;
			that.loading = true;
			let requestData = {
				pageSize: 10,
				pageNum: that.currentPage,
				coinDetailId: that.search_orderNo,
				orderPhone: that.search_orderPhone,
				orderStatus: that.search_orderStatus,
				// userPhone: that.search_uCode,
				// orderNo: that.search_number,
				// orderSerialNo: that.search_serial,
				// orderPayType: that.search_payType,
				// orderPayStatus: that.search_orderStatus,
				testCreateTsBegin: that.search_startDate,
				testCreateTsEnd: that.search_endDate,
				// typeChannel: 1
				type: that.type
			};
			Api.lensOrderList(requestData).then(
				(res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach((v) => {
							list.push({
								...v,
								orderPhone: v.orderPhone,
								// ------------
								id: v.orderId,
								orderImg: v.orderImg,
								number: v.orderNo,
								num: v.num,
								amount: v.orderTotalMoneyYuan,
								addr: v.address,
								serial: v.orderSerialNo || '',
								uCode: v.userPhone,

								payTypeValue: v.orderPayType,
								payTypeLabel: that.mapPayTypeValueToLabel(v.orderPayType),
								time: v.createTs,
								sendValue: v.sendFlag,
								sendLabel: that.mapSendValueToLabel(v.sendFlag),
								orderStatusValue: v.orderPayStatus,
								orderStatusLabel: that.mapOrderStatusValueToLabel(v.orderPayStatus)
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 比较开始时间和结束时间
		compareSearchDate() {
			if (this.search_startDate && this.search_endDate) {
				var startTime = new Date(this.search_startDate).getTime(),
					endTime = new Date(this.search_endDate).getTime();
				if (endTime < startTime) {
					this.search_endDate = '';
					this.$message.warning('结束时间不能小于开始时间！');
				}
			}
		},
		// 把支付类型转为文字
		mapPayTypeValueToLabel(value) {
			let result = '';
			this.appPayType.forEach((v) => {
				value == v.id && (result = v.name);
			});
			return result;
		},
		// 把发货状态转为文字
		mapSendValueToLabel(value) {
			let result = '';
			this.appSendStatus.forEach((v) => {
				value == v.id && (result = v.name);
			});
			return result;
		},
		// 把订单状态转为文字
		mapOrderStatusValueToLabel(value) {
			let result = '';
			this.appOrderStatus.forEach((v) => {
				value == v.id && (result = v.name);
			});
			return result;
		}
	}
};
</script>

<style scoped></style>
